import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { loadRuntimeConfig } from "./loadConfig";
import "./index.css";
import "./styles/tailwind.css";
import App from "./App";
import { configureClient } from "./api/apiClient";

(async () => {
  await loadRuntimeConfig();
  configureClient();
  const BASE = (import.meta.env.BASE_URL || "/ui/").replace(/\/$/, ""); // '/ui'
  console.log("[BOOT] BASE_URL =", BASE);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App base={BASE} />
    </StrictMode>
  );
})();
